import React, { useState, useEffect } from 'react';
import { Card, CardBody, Grid, GridItem, Heading, Text, Badge, Divider, Button, Box, VStack } from '@chakra-ui/react';
import PaperCardAgenda from './PaperCardAgenda';
import { likeItemOutside, voteForPaper } from '../../utils/api';

const PartitionCard = ({ item, index, items, onShowItems, isAgendaTab }) => {
  const [conferenceItems, setConferenceItems] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [hasConferenceItems, setHasConferenceItems] = useState(false);
  const isSpecialCategory = ['Registration', 'Remarks', 'Plenary talk', 'Coffee break', 'Lunch', 'Apero'].includes(item.category);

  useEffect(() => {
    const checkConferenceItems = async () => {
      const fetchedItems = await onShowItems(item.session);
      setHasConferenceItems(fetchedItems && fetchedItems.length > 0);
    };
    checkConferenceItems();
  }, [item.session, onShowItems]);

  const handleAdd = async (paperId) => {
    await likeItemOutside(paperId);
    console.log(`Added document id ${paperId} to agenda from program`);
    const success = await voteForPaper(paperId);
    console.log(`Item id: ${paperId}, vote success: ${success}`);
  };

  const handleToggleItems = async () => {
    if (isExpanded) {
      setIsExpanded(false);
      setConferenceItems([]);
    } else {
      const fetchedItems = await onShowItems(item.session);
      console.log(`Fetched items: ${fetchedItems}`)
      setConferenceItems(fetchedItems || []);
      setIsExpanded(true);
    }
  };

  let cardContent = (
    <>
      <Card mb={8} boxShadow="md" bg="gray.700" px={1}>
        <CardBody height="100%">
          <Grid
            templateAreas={`"timeLocation"
                            "header"
                            "title"
                            "people"`}
            gridTemplateRows={'auto auto auto auto'}
            gridTemplateColumns={'1fr'}
            minHeight="100px"
            gap="1"
          >
            <GridItem area={'timeLocation'} display="flex" justifyContent="space-between" alignItems="center">
              <Text fontSize="sm" color="gray.300">
                {item.time_start} - {item.time_end}
              </Text>
              {item.location && (
                <Box display="flex" alignItems="center">
                  <Badge colorScheme="teal">{item.location}</Badge>
                </Box>
              )}
            </GridItem>
            <GridItem area={'header'} display="flex" justifyContent="space-between" alignItems="center">
              <Heading size="lg" wordBreak="break-word" color="gray.100" fontWeight="bold">
                {item.session}
              </Heading>
            </GridItem>
            {item.session_title && (
              <GridItem area={'title'}>
                <Text wordBreak="break-word" fontSize="md" color="gray.200">
                  {item.session_title}
                </Text>
              </GridItem>
            )}
            {item.session_people && (
              <GridItem area={'people'}>
                <Text wordBreak="break-word" fontSize="sm" color="gray.400" fontStyle="italic">
                  {item.session_people}
                </Text>
              </GridItem>
            )}
          </Grid>
          {hasConferenceItems && (
            <Button size="sm" onClick={handleToggleItems} mt={4} colorScheme="teal">
              {isExpanded ? 'Hide' : 'Show'} Session Items
            </Button>
          )}
        </CardBody>
      </Card>

      {isExpanded && (
        <VStack spacing={0}>
          {conferenceItems.map((conferenceItem) => (
            <PaperCardAgenda
              key={conferenceItem.id}
              title={conferenceItem.title}
              authors={conferenceItem.authors}
              abstract={conferenceItem.abstract || ''}
              keywords={''}
              date={conferenceItem.date}
              time_start={conferenceItem.time_start}
              time_end={conferenceItem.time_end}
              location={conferenceItem.location}
              onAdd={() => handleAdd(conferenceItem.id)}
              showAddButton={!isAgendaTab}
            />
          ))}
        </VStack>
      )}
      {index !== items.length - 1 && <Divider my={6} />}
    </>
  )

  return (
    <React.Fragment>
      {!isAgendaTab && cardContent}
      {(isAgendaTab && (hasConferenceItems || isSpecialCategory)) ? cardContent : null}
    </React.Fragment>
  );
};

export default PartitionCard;
